module.exports = __webpack_public_path__ + "static/media/clock_sm.212a7822.svg";